import type { GetProductResponse } from './product'

export const getProductMock: GetProductResponse = {
  id: '0106bb6f-3975-4794-b9a0-7d920669484c',
  legacyId: '290057',
  link: {
    type: 'internal',
    name: 'product',
    pattern: '/:locale/p/:slugV2/:uuid',
    params: {
      id: '290057',
      slug: 'iphone-11-64-go-noir-debloque-tout-operateur-pas-cher',
      slugV2: 'iphone-11-64-go-noir-debloque-tout-operateur',
      uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
      locale: 'fr-fr',
    },
    query: {},
    hash: {},
    href: 'https://www.backmarket.fr/fr-fr/p/iphone-11-64-go-noir-debloque-tout-operateur/0106bb6f-3975-4794-b9a0-7d920669484c',
  },
  type: 'refurbished',
  title: 'iPhone 11',
  rawTitle: 'iPhone 11 64 Go Noir Débloqué',
  model: 'iPhone 11',
  priceWhenNew: { amount: '589.00', currency: 'EUR' },
  subTitleElements: ['64 Go', 'Noir', 'Débloqué'],
  isSwapEligible: true,
  images: [
    {
      url: 'https://d1eh9yux7w8iql.cloudfront.net/product_images/290057_aeb6f021-ed9e-45a8-b247-c336792a9dd6.jpg',
      alt: 'iPhone 11 first',
    },
    {
      url: 'https://d1eh9yux7w8iql.cloudfront.net/product_images/290057_806d8669-f119-4949-b7d3-d87142d8a045.jpg',
      alt: 'iPhone 11 second',
    },
    {
      url: 'https://d1eh9yux7w8iql.cloudfront.net/product_images/290057_a5056174-da9b-4195-a513-2ac498bb4afd.jpg',
      alt: 'iPhone 11 third',
    },
  ],
  compatibleCarriers: [],
  trackingDetails: {
    brand: 'Apple',
    categories: ['1_Téléphones', '4_Smartphones', '5_Smartphone'],
    category3MarketplaceCategory_ID: 2,
    category3Name: 'Smartphone',
    color: 'Noir',
  },
  tags: [
    'Choisir le reconditionné pour aider à réduire le gâchis électronique',
  ],
  insurancesOffers: {
    additionalBenefits: ['Assurance Casse et Vol', 'Assurance casse'],
  },
  eWaste:
    'Choisir le reconditionné pour aider à réduire le gâchis électronique',
  description:
    '<div><strong><br>iPhone 11 64 Go - Noir - Débloqué<br></strong></div> <div><strong>Lors de sa keynote du 10 septembre 2019, Apple a présenté sa 11ème génération d’iPhone. Cette année-là, la marque à la pomme a donc lancé 3 nouveaux modèles à savoir : l’iPhone 11, l’iPhone 11 Pro et l’iPhone 11 Pro Max. Concernant le successeur de l’iPhone XR, celui-ci est un superbe smartphone de haute technologie doté d’une coque monobloc en aluminium Noir faisant 150.9 mm de long sur 75.7 mm de large avec une épaisseur de 8.3 mm pour un poids de 194g.</strong></div> <ul> <li><strong>Date de sortie : </strong><br>10 septembre 2019<br><br></li> <li><strong>Capacité :</strong><br>64 Go<br><br></li> <li><strong>Couleur :</strong><br>Noir</li> <li><strong>Écran :</strong></li> </ul> <div>- Écran Liquid Retina HD LCD Multi-Touch tout écran de 6,1 pouces<br>- Taille : 6.1 pouces<br>- Technologie : Haptic Touch<br>- Affichage : True Tone à large gamme de couleur (P3)<br>- Résolution : 1 792 x 828 pixels à 326 ppp<br>- Contraste : 1 400:1 <br><br></div> <ul> <li><strong>Appareil Photo : </strong></li> </ul> <div>Pour la partie photo/vidéo, qui fait partie des critères les plus importants lors du choix d’un smartphone, Apple n’a pas fait dans la demi-mesure avec son APN principal de 12 mégapixels avec ouverture ƒ/2,4 , objectif de 26mm, et Flash True Tone LED. Cet appareil photo propose de nombreuses fonctionnalités : zoom numérique jusqu’à 5x, zoom optique arrière 2x, mode panoramique jusqu’à 63 mégapixels, smart HDR nouvelle génération, mise au point par automatique continue avec Focus Pixels, prise en charge du ralenti vidéo en 1080p à 120 i/s ou 240 i/s, enregistrement vidéo en Ultra HD 4K 1080p à à 30 ou 60 i/s. Quant à l’APN frontal, il s’agit d’une caméra de 12 mégapixels avec ouverture ƒ/1,8 et Retina Flash.<br><br></div> <ul> <li><strong>Système d’exploitation :</strong><br>iOS 13</li> <li><strong>Batterie :</strong></li> </ul> <div>- Jusqu’à 1 heure d’autonomie de plus que l’iPhone XR<br>- Batterie lithium?ion rechargeable intégrée<br><br></div> <ul> <li><strong>Autres Caractéristiques de l’iPhone 11 :</strong></li> </ul> <div> L’iPhone 11 apporte avec lui son lot de technologies. Doté de deux haut-parleurs stéréo intégrés, d’un bouton latéral, d’un bouton volume +/- , d’un connecteur Lightning et de micro intégrés, ce smartphone de dernière génération propose un beau design sobre et élégant avec des courbures légères sur chaque côté et une finition parfaite.</div> <div>Résistant à l’eau, la poussière et aux éclaboussures. Indice IP68. DAS : 0.95 W/kg(10g). Un revêtement oléophobe permet à l’écran de résister aux traces de doigt.<br><br></div> <div>L’<strong>iPhone 11</strong> reconditionné pas cher utilise plusieurs connectivités sans fil, comme le NFC avec mode lecteur seulement,le Bluetooth 5.0 Low Energy avec A2DP et le Wi-Fi 6 802.11ax avec MIMO 2x2. Plusieurs senseurs sont aussi présents dans le smartphone : un capteur d’empreinte digitale Touch ID incrusté dans le bouton Home, Face ID, un accéléromètre, un capteur de luminosité ambiante, un détecteur de proximité, un baromètre et un gyroscope à trois axes.</div> <div><br>Sinon, l’iPhone 11 dispose d’autres caractéristiques techniques des plus alléchantes. Sous sa superbe armature Noire, cet appareil cache un ultrapuissant chipset, l’Apple A13 Bionic. Doté d’une architecture 64 bits, et d’un système neuronal troisième génération, ce SoC embarque un processeur à 6 cœurs (4 cœurs haute efficacité énergétique + 2 cœurs haute performance. Mémoire de stockage de 64 Go est présente sur cet <strong>iPhone 11</strong>. <br><br></div> <div><br>Avec cet appareil <strong>iPhone 11 Noir</strong> haut de gamme de dernière génération, vous ferez de nombreux jaloux autour de vous. Ce smartphone vous permettra de vous divertir, de planifier votre emploi du temps, d’échanger avec vos proches, d’immortaliser les moments forts de votre vie à travers des vidéos et des photos de qualité exceptionnelle, etc.., </div>',
  links: {
    FR: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'iphone-11-64-go-noir-debloque-tout-operateur-pas-cher',
        slugV2: 'iphone-11-64-go-noir-debloque-tout-operateur',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'fr-fr',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.fr/fr-fr/p/iphone-11-64-go-noir-debloque-tout-operateur/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    BE: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'iphone-11-64-go-noir-debloque-tout-operateur-pas-cher',
        slugV2: 'iphone-11-64-go-noir-debloque-tout-operateur',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'fr-be',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.be/fr-be/p/iphone-11-64-go-noir-debloque-tout-operateur/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    ES: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'iphone-11-64-gb-negro-libre-segunda-mano',
        slugV2: 'iphone-11-64-gb-negro-libre',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'es-es',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.es/es-es/p/iphone-11-64-gb-negro-libre/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    DE: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'iphone-11-64-gb-schwarz-ohne-vertrag-gebraucht',
        slugV2: 'iphone-11-64-gb-schwarz-ohne-vertrag',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'de-de',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.de/de-de/p/iphone-11-64-gb-schwarz-ohne-vertrag/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    IT: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'iphone-11-64-go-nero-sbloccato-miglior-prezzo',
        slugV2: 'iphone-11-64-go-nero-sbloccato',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'it-it',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.it/it-it/p/iphone-11-64-go-nero-sbloccato/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    GB: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'second-hand-iphone-11-64-gb-black-unlocked',
        slugV2: 'iphone-11-64-gb-black-unlocked',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'en-gb',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.co.uk/en-gb/p/iphone-11-64-gb-black-unlocked/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    AT: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'iphone-11-64-gb-schwarz-ohne-vertrag-gebraucht',
        slugV2: 'iphone-11-64-gb-schwarz-ohne-vertrag',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'de-at',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.at/de-at/p/iphone-11-64-gb-schwarz-ohne-vertrag/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    NL: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'iphone-11-64-gb-zwart-simlockvrij-niet-duur',
        slugV2: 'iphone-11-64-gb-zwart-simlockvrij',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'nl-nl',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.nl/nl-nl/p/iphone-11-64-gb-zwart-simlockvrij/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    FI: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'iphone-11-64-gb-musta-lukitsematon-harmaa-kaytetty',
        slugV2: 'iphone-11-64-gb-musta-lukitsematon',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'fi-fi',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.fi/fi-fi/p/iphone-11-64-gb-musta-lukitsematon/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    PT: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'iphone-11-64-gb-preto-desbloqueado-barato',
        slugV2: 'iphone-11-64-gb-preto-desbloqueado',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'pt-pt',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.pt/pt-pt/p/iphone-11-64-gb-preto-desbloqueado/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    IE: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'second-hand-iphone-11-64-gb-black-unlocked',
        slugV2: 'iphone-11-64-gb-black-unlocked',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'en-ie',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.ie/en-ie/p/iphone-11-64-gb-black-unlocked/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    GR: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'iphone-11-64-gb-ftino-proion',
        slugV2: 'iphone-11-64-gb',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'el-gr',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.gr/el-gr/p/iphone-11-64-gb/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    SK: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'lacne-iphone-11-64-gb-cierna-neblokovany',
        slugV2: 'iphone-11-64-gb-cierna-neblokovany',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'sk-sk',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.sk/sk-sk/p/iphone-11-64-gb-cierna-neblokovany/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
    SE: {
      type: 'internal',
      name: 'product',
      pattern: '/:locale/p/:slugV2/:uuid',
      params: {
        id: '290057',
        slug: 'begagnad-iphone-11-64-gb-svart-olast',
        slugV2: 'iphone-11-64-gb-svart-olast',
        uuid: '0106bb6f-3975-4794-b9a0-7d920669484c',
        locale: 'sv-se',
      },
      query: {},
      hash: {},
      href: 'https://www.backmarket.se/sv-se/p/iphone-11-64-gb-svart-olast/0106bb6f-3975-4794-b9a0-7d920669484c',
    },
  },
}
